<template>
  <div>
    <Chart :cdata="cdata" />
  </div>
</template>

<script>
import Chart from './chart.vue'
import timeoutMixin from '@/utils/timeoutMixin'
export default {
  mixins: [timeoutMixin],
  data () {
    return {
      cdata: {
        category: [
          "2.1",
          "2.2",
          "2.3",
          "2.4",
          "2.5",
          "2.6",
          "2.7",
          "2.8",
          "2.9",
          "2.10",
          "2.11",
          "2.12",
          "2.13",
          "2.14",
          "2.15"
        ],
        lineData: [
          18092,
          20728,
          24045,
          28348,
          62808,
          86097,
          79867,
          44715,
          48444,
          80415,
          56061,
          32677,
          59521,
          67560,
          18092
        ],
        barData: [
          4600,
          5000,
          5500,
          6500,
          7500,
          8500,
          9900,
          12500,
          14000,
          21500,
          23200,
          24450,
          25250,
          33300,
          4600,
        ],
        rateData: []
      },
      
      data: [
        {
          lineData: [
            18092,
            20728,
            24045,
            28348,
            32808,
            36097,
            39867,
            44715,
            48444,
            50415,
            56061,
            62677,
            59521,
            67560,
            18092
          ],
          barData: [
            4600,
            5000,
            5500,
            6500,
            7500,
            8500,
            9900,
            12500,
            14000,
            21500,
            23200,
            24450,
            25250,
            33300,
            4600
          ]
        },
        {
          lineData: [
            39867,
            44715,
            48444,
            50415,
            56061,
            62677,
            38092,
            40728,
            44045,
            38348,
            59521,
            67560,
            18092,
            32808,
            36097,
          ],
          barData: [
            4600,
            33300,
            4600,
            23200,
            24450,
            25250,
            15500,
            16500,
            14500,
            5000,
            21500,
            14000,
            8500,
            9900,
            12500,
          ],
        },
        {
          lineData: [
            39867,
            44715,
            56061,
            67560,
            36097,
            62677,
            48444,
            50415,
            18092,
            20728,
            18092,
            32808,
            24045,
            28348,
            59521,
          ],
          barData: [
            4600,
            23200,
            24450,
            25250,
            5500,
            4600,
            9900,
            12500,
            21500,
            33300,
            5000,
            14000,
            8500,
            6500,
            7500
          ],
        },
      ]
    };
  },
  components: {
    Chart,
  },
  mounted() {
    this.title = 'power 中中'
    // this.changeData(this.data)
  },
  methods: {
    changeData(data, timeout = 3000) {
      if (this.title) {
        // console.log(this.title, this.index)
      }
      let index = this.index >= data.length ? 0 : this.index
      // 更新数据
      this.cdata.lineData = this.data[index].lineData
      this.cdata.barData = this.data[index].barData

      index ++
      this.index = index
      this.timeoutIndex = setTimeout(() => {
        this.changeData(data)
      }, timeout)
    }
  }
};
</script>

<style lang="scss" scoped>
</style>